var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-view-cameras d-flex flex-column align-items-start"},_vm._l((_vm.items),function(ref){
var id = ref.id;
var name = ref.name;
var link = ref.link;
return _c('el-link',{key:id,staticClass:"mb-1",attrs:{"icon":"el-icon-document","type":"primary","underline":false,"target":"_blank","href":_vm.addSlashIfNeeded(link)}},[_vm._v(_vm._s(name)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }